export default {
	init($) {
	

		$(document).on("click", ".coupon-apply", async function (event) {
			event.preventDefault()
			var couponCode = $(this).siblings(".coupon-input").val() // Get the value of the input field
			$("input[name='coupon_code']").val(couponCode)

			try {
				// var isTradeIn = await checkTradein(couponCode)
				var isTradeIn = false // Disable trade-in check
		
				// Submit the first form
				if (isTradeIn === false) {
					let triggeredForm = $("form.checkout_coupon")
					triggeredForm.trigger('submit')
				}
			} catch (error) {
				console.error("Error checking trade-in:", error);
			}

		})
	

		
		$(".coupon-input").keydown(function (event) {
			// Check if Enter key was pressed (key code 13)
			if (event.keyCode === 13) {
			event.preventDefault()
			}
		})



		/**
		 * Check coupons 
		 */
		// function checkTradein(couponCode) {
		// 	return new Promise((resolve, reject) => {

		// 		$.ajax({
		// 			type: 'POST',
		// 			url: my_ajax_object.ajax_url,
		// 			data: {
		// 				action: 'intercept_apply_coupon_ajax_request',
		// 				coupon_code: couponCode
		// 			},
		// 			success: function (response) {
		// 				if (response.success) {
		// 					$(document.body).trigger("update_checkout")
		// 					resolve(true)
		// 				} else {
		// 					resolve(false)
		// 				}
		// 			},
		// 			error: function () {
		// 				console.log('An error occurred while applying the coupon.')
		// 				reject("Failed to check trade-in status.");
		// 			},

		// 		})
		// 	})

		// }
	
	},
}